// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__2Dyen","link":"Nav_link__rWB+H","active":"Nav_active__P4k1r"};